
import clsx from 'clsx'
import { Link, useNavigate } from "react-router-dom";
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import { Topbar } from './Topbar'
import { CustomDateFormate } from '../../../../utils/date'
import { Activity, Award, BarChart3, FileText, Flag, LayoutDashboard, Settings, Target } from 'lucide-react'
import { useCanOpenDashboardTab } from '../../../../app/modules/Dashboard/core/tabRights'
const menuItems = [
  {
    icon: Activity,
    title: 'Pipeline Status',
    slug: 'dashboard',
  },
  {
    icon: Flag,
    title: 'Stage Gates',
    slug: 'stagegates',
  },
  {
    icon: Award,
    title: 'Panoptic Evaluation',
    slug: 'evaluation',
  },
  {
    icon: Target,
    title: 'Project Portfolio',
    slug: 'projects',
  },
  {
    icon: BarChart3,
    title: 'Investor Prospectus',
    slug: 'prospectus',
  },
  {
    icon: LayoutDashboard,
    title: 'Strat Plan KPI’s',
    slug: 'kpi_monitoring',
  },
  {
    icon: FileText,
    title: 'Reports',
    slug: 'reports',
  },
  {
    icon: Settings,
    title: 'Settings',
    slug: 'settings',
  },
]
export function HeaderWrapper() {
  const navigate = useNavigate();
  const canOpenTab = useCanOpenDashboardTab();
  const { classes, attributes } = useLayout()
  const today = new Date();
  const formattedDate = CustomDateFormate(today);
  const handleDashboardNavigation = (slug: string) => {
    navigate(`/dashboard${slug === "dashboard" ? '' : `/${slug}`}`, { replace: true });
  }
  return (
    <>
      <div
        id='kt_header'
        className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
        data-kt-sticky='true'
        data-kt-sticky-name='header'
        data-kt-sticky-offset="{default: '0px', lg: '0px'}"
        {...attributes.headerMenu}
        style={{ background: "#081441" }}
      >
        <div className={clsx(classes.headerContainer.join(' '), 'd-flex align-items-center justify-content-between')}>
          <div className='header-logo me-5 me-md-10'>
            <div className="d-flex align-items-center">
              <button
                className="btn btn-icon btn-active-color-primary w-40px h-40px d-lg-none me-2"
                id="kt_app_sidebar_mobile_toggle"
              >
                <KTIcon
                  className={"fs-40px"}
                  iconName="burger-menu"
                />
              </button>
              <Link to="/pages/home">
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('media/svg/logos/wcg-small-logo.svg')}
                  className='logo-default h-40px'
                />
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('media/svg/logos/wcg-small-logo.svg')}
                  className='logo-sticky h-40px'
                />
              </Link>
              <div className='d-flex flex-column ms-3'>
                <span className="text-white fw-bold fs-3 d-none d-md-inline">WCG</span>
                <span className='text-white fs-7 d-none d-sm-inline'>{formattedDate}</span>
              </div>
            </div>
          </div>

          <div className='d-flex align-items-center align-items-center' id='kt_header_nav'>
          </div>

          {/* begin::Wrapper */}
          <div className='d-flex align-items-stretch'>

            <div className='d-flex align-items-stretch flex-shrink-0 ms-2'>
              <Topbar />
            </div>
          </div>
          {/* end::Wrapper */}
        </div>
      </div>
      <div
        id="kt_app_sidebar"
        className="app-sidebar flex-column"
        data-kt-drawer="true"
        data-kt-drawer-name="app-sidebar"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="225px"
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
      >
        <div className='menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold my-5 my-lg-0 align-items-stretch'>
          {menuItems.filter((item) => canOpenTab(item.slug)).map((item) => (
            <div className="menu-item me-lg-1" key={item.slug} onClick={() => handleDashboardNavigation(item.slug)}>
              <div className="menu-link py-3">
                <span className="menu-title"><item.icon size={16} className="me-2" /> {item.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
